import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const ENTITIES_TABLE_STATE_STORAGE_KEY = "userEntitiesList";

export const ENTITIES_LIST_COLUMN_IDS = {
    NAME: "name",
    DESCRIPTION: "description",
    ACCESS_RIGHT: "accessRight",
} as const;

export const entitiesListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: ENTITIES_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const entitiesListColumnFiltersCodecMap = {
    [ENTITIES_LIST_COLUMN_IDS.NAME]: withModeCodec(encodedArrayCodec),
    [ENTITIES_LIST_COLUMN_IDS.ACCESS_RIGHT]: withModeCodec(encodedArrayCodec),
};
